import React, { useState } from "react";
import { S_FORMAT_INR_CURRENCY_AND_AMOUNT } from "../../../includes/staticData";
import { Link } from "react-router-dom";
import { Col, Modal } from "react-bootstrap";
import BlockLoading from "../../../blocks/BlockLoading";
import RaisedVsReceived from "../stats/RaisedVsReceived";
import VendorsSummery from "../stats/VendorsSummery";
import FixedcostMonthlySummary from "../stats/FixedcostMonthlySummary";
import DedicatedMonthlySummary from "../stats/DedicatedMonthlySummary";
import "../../../../assets/css/dashboard.css"
import PlatformFeeSummary from "../stats/PlatformFeeSummary";
import GSTSummaryDetails from "../stats/GSTSummaryDetails";
const DashboardCard = ({ title, values = [], loading, currency = false, view, split = false, modal_size = 'xl', bg = "" }) => {

  const [showModal, setShowModal] = useState(false);
  const [selectedView, setSelectedView] = useState(null);

  const handleView = () => () => {
    setSelectedView(view);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedView(null);
  };

  const viewComponents = {
    raisedVsReceived: RaisedVsReceived,
    vendorsSummery: VendorsSummery,
    fixedcostMonthlySummary: FixedcostMonthlySummary,
    dedicatedMonthlySummary: DedicatedMonthlySummary,
    PlatformFeeSummary: PlatformFeeSummary,
    GSTSummaryDetails: GSTSummaryDetails,
  };

  const SelectedComponent = viewComponents[selectedView];

  return (
    <>

      <Col xs={12} sm={6} md={4}>
        <div className={`card flex-fill card-opacity rounded-32 dashboard-card ${bg}`}>
          <div className="card-body">
            <div className="row mb-1 align-items-center">
              <div className="col mt-0">
                <h5 className="card-title">{title}
                </h5>
              </div>
              <div className="col-auto" style={{ marginTop: "-11px" }}>
                {view && (
                  <span className="badge badge-primary-light">
                    <Link onClick={handleView()}>
                      <i className="bx bx-info-circle"></i>
                    </Link>
                  </span>
                )}
              </div>
            </div>
            {loading ? (
              <BlockLoading />
            ) : (
              <>
                {Array.isArray(values) && values.length > 0 ? (
                  <>


                    <div className="box-wrapper">
                      {
                        values.map((item, index) => {
                          const img_path = `/assets/img/${index + 1}.svg`;
                          console.log(index)
                          return (
                            <div className="internal-wrapper" key={index}>
                              <div className="icon-wrapper">
                                <img
                                  src={
                                    process.env.PUBLIC_URL + img_path
                                  }
                                  alt="eLuminous Logo"
                                  className="logo"
                                />
                              </div>
                              <div className="title-wrapper">
                                <h6>{item.label}</h6>
                                <h2>{S_FORMAT_INR_CURRENCY_AND_AMOUNT(item.amount || 0)}</h2>
                              </div>
                            </div>
                          )
                        })
                      }
                    </div>
                    {/* <div className="d-flex justify-content-between flex-wrap">
                      {values.map((item, index) => (
                        <div key={index} className="me-3">
                          <strong>{item.label}</strong>
                        </div>
                      ))}
                    </div>
                    <div className="d-flex justify-content-between flex-wrap">
                      {values.map((item, index) => (
                        <p className="mt-0 mb-2" key={index}>{S_FORMAT_INR_CURRENCY_AND_AMOUNT(item.amount || 0)}</p>
                      ))}
                    </div> */}
                  </>
                ) : (
                  <h5 className="mt-0 mb-1">{S_FORMAT_INR_CURRENCY_AND_AMOUNT(values || 0)}</h5>
                )}

              </>
            )}


          </div>
        </div>
      </Col>

      <Modal
        show={showModal}
        onHide={handleClose}
        size={modal_size}
        centered
        backdrop="static"
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>{title || ""}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {SelectedComponent ? <SelectedComponent /> : null}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DashboardCard;